// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4637":"7cae281e","7688":"83f4558b","8915":"e80da2aa"}[chunkId] + ".chunk.css";
};